/** Pricing: the app's real plans, monthly or yearly. */
import { GET_STARTED_URL } from '@/data/links'

export const PRICING = {
  eyebrow: 'Pricing',
  title: 'Plans for every office',
  note: 'All prices in SAR, VAT not included.',
  billing: [
    { id: 'monthly', label: 'Monthly', unit: 'SAR / month' },
    { id: 'yearly', label: 'Yearly', unit: 'SAR / year' },
  ],
  free: 'Free',
  // Prices, seats and features from the app's plan catalog (app.meetnplan,
  // src/shared/lib/billing/plans.js): keep them in step with it. A free plan
  // shows `free` and its `freeNote` in place of a price.
  plans: [
    {
      name: 'Free',
      icon: 'calendar',
      description: 'Try everything.',
      price: { monthly: 0, yearly: 0 },
      freeNote: '14 days',
      users: 'Up to 10 users',
      features: [
        '1 room',
        'Messages',
        'Google Calendar & Meet',
        'Guest invites',
        'Priority support',
      ],
      cta: { label: 'Start free', href: GET_STARTED_URL },
    },
    {
      name: 'Basic',
      icon: 'user',
      description: 'Small teams.',
      price: { monthly: 149, yearly: 1788 },
      users: 'Up to 10 users',
      features: [
        '1 room',
        '2 admins',
        '1,000 meeting emails a month',
        'Messages',
        'HR & reception',
      ],
      cta: { label: 'Choose Basic', href: `${GET_STARTED_URL}?plan=basic` },
    },
    {
      name: 'Business',
      icon: 'users',
      description: 'Most popular.',
      price: { monthly: 399, yearly: 4788 },
      users: 'Up to 40 users',
      features: [
        '4 rooms',
        '5 admins',
        'Google Calendar & Meet',
        '20 guest invites',
        'Priority support',
      ],
      cta: { label: 'Choose Business', href: `${GET_STARTED_URL}?plan=business` },
      featured: true,
    },
    {
      name: 'Enterprise',
      icon: 'building',
      description: 'Every branch.',
      price: { monthly: 799, yearly: 9588 },
      users: 'Up to 150 users',
      features: [
        '12 rooms',
        '10 admins',
        'Dedicated account manager',
        'Unlimited emails',
        'Every feature',
      ],
      cta: {
        label: 'Choose Enterprise',
        href: `${GET_STARTED_URL}?plan=enterprise`,
      },
    },
  ],
}
